import { Dayjs } from 'dayjs';
import { array, boolean, mixed, number, object, ObjectSchema, string } from 'yup';

import { InquirySourceDto, ProcessStatusDto } from '@/api/generated';
import {
  selectSearchOptionRequiredFieldsValidation,
  selectSearchOptionRequiredValidation,
} from '@/utils/form/selectSearchOptionOptional.validation.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix';
import { ProcessesListSearchFormModel } from '@/views/processes/list/model/ProcessesListSearchForm.model.ts';

export const useProcessesListFormValidation = (): ObjectSchema<ProcessesListSearchFormModel> => {
  const { t } = useTranslationWithPrefix('validation');

  return object().shape({
    createdFrom: mixed<Dayjs>().nullable(),
    createdTo: mixed<Dayjs>().nullable(),
    customerId: selectSearchOptionRequiredFieldsValidation<number>(number(), t).nullable(),
    fullTextSearchInput: string()
      .optional()
      .min(3, t('minLength', { min: 3 }))
      .transform((value, originalValue) => (originalValue === '' ? undefined : value)),
    inquirySources: array()
      .of(selectSearchOptionRequiredValidation<InquirySourceDto>(string(), t))
      .required(t('general.required')),
    isNeedingAttention: boolean(),
    processContactId: selectSearchOptionRequiredFieldsValidation<number>(number(), t).nullable(),
    processCreatorId: selectSearchOptionRequiredFieldsValidation<string>(string(), t).nullable(),
    processOwnerId: selectSearchOptionRequiredFieldsValidation<string>(string(), t).nullable(),
    statuses: array()
      .of(selectSearchOptionRequiredValidation<ProcessStatusDto>(string(), t))
      .required(t('general.required')),
    updatedFrom: mixed<Dayjs>().nullable(),
    updatedTo: mixed<Dayjs>().nullable(),
  });
};
